export const DEFAULT_LANGUAGE_CODE = 'en'
const SELECTED_LANGUAGE_LOCAL_STORAGE_KEY = 'selectedLanguageId'

export class I18nextLanguageDetector {
  type = 'languageDetector'
  init() {}
  detect() {
    return localStorage.getItem(SELECTED_LANGUAGE_LOCAL_STORAGE_KEY) || DEFAULT_LANGUAGE_CODE
  }
  cacheUserLanguage(newLanguage) {
    return localStorage.setItem(SELECTED_LANGUAGE_LOCAL_STORAGE_KEY, newLanguage)
  }
}
